import { render, staticRenderFns } from "./LateralFichaElement.vue?vue&type=template&id=f9d26eb4&"
import script from "./LateralFichaElement.vue?vue&type=script&lang=js&"
export * from "./LateralFichaElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports